import {useEffect} from 'react'

export function useGoogleTagManager(gtmId: string): void {
  useEffect(() => {
    if (!gtmId) return

    // verifico si ya existe
    if (document.querySelector('script[data-gtm="true"]')) {
      return
    }
    
    // verifico si dataLayer ya existe para evitar duplicación
    if (window['dataLayer']) {
      return
    }

    // creo array dataLayer
    window['dataLayer'] = [];
    window['dataLayer'].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })

    // creo el script
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

    // añado al head como primer elemento script
    if (document.head.firstChild) {
      // si head ya tiene elementos, inserto antes del primer elemento
      document.head.insertBefore(scriptTag, document.head.firstChild)
    } else {
      // si head está vacío, lo añado
      document.head.appendChild(scriptTag);
    }
    
    // añado el noscript iframe al inicio del body
    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'

    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)

    // no es necesario limpieza, GTM generalmente se mantiene durante toda la sesión
  }, [gtmId])
}